import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Export = ApplicationRecord.extend({
  attrs: {
    id: attr(),
    filename: attr(),
    download_url: attr(),
    kind: attr(),
    requester_id: attr(),
    state: attr(),
    progress: attr(),
    created_at: attr(),
  },
  static: {
    endpoint: '/exports',
    jsonapiType: 'exports-exports',
  },
});

export default Export;
